import React, { useRef, forwardRef, Fragment } from 'react'
import { useProjectStore } from '@vt/hooks'
import { Button } from '@ow/comps'
import { getQuery } from '@vt/utils'
import { IconMaps } from '@ow/icons'
import { useCustomInfoSWR } from '@vt/apis/lib-ex/v2/login'
import { getApiVersion } from '@vt/apis'
import clsx from 'clsx'
import { pick } from 'lodash-es'
import NavigateAdaptor from '../hooks/navigation/adaptor'
import useRouteTo from '../hooks/navigation/use-route-to'
import { useNavStore } from './NavStoreProvider'
import MenuFirst from './first'
import MenuSecond from './second'
import TreeNav from './TreeNav'
import UserCenter from './user-center'
import UpdPassword from './updPassword'
import { OperateContainer } from './hooks/operate'

const formatRightElements = (rightElements = []) => {
  let avatarInfo
  let actions
  let isLogoutVisible
  const excludeTypes = ['user_avatar', 'logout', 'user_action']
  const res = []
  rightElements.forEach((ele) => {
    const { type } = ele
    if (excludeTypes.includes(type)) {
      if (type === 'user_avatar') avatarInfo = ele
      if (type === 'logout' || type === 'user_action') {
        actions = ele.children || []
        isLogoutVisible = true
      }
    } else {
      res.push(ele)
    }
  })
  if (avatarInfo && isLogoutVisible) {
    res.push({
      ...avatarInfo,
      actions,
      type: 'user_avatar_logout',
    })
  } else if (avatarInfo && !isLogoutVisible) {
    res.push({
      ...avatarInfo,
      type: 'user_avatar',
    })
  }
  console.log(res, 'upduopdupd')
  return res
}

const UserInfoComp = forwardRef(
  ({ mode, onMenuSelect, rightElements = [], appId }, ref) => {
    const { userInfo } = useProjectStore((s) => pick(s, ['userInfo']))
    const { routeTo } = useRouteTo({ appId })
    return (
      <div
        ref={ref}
        className={clsx(
          mode === 'vertical'
            ? 'flex items-center justify-center'
            : 'ml-auto flex items-center'
        )}
      >
        {formatRightElements(rightElements).map((element, index) => {
          return (
            <Fragment key={`${element.type}-${index}`}>
              {/* 重定向到1.0 */}
              {element.type === 'redirectLink' && (
                <div
                  onClick={() => {
                    routeTo({
                      project: 'redirect',
                      navType: element.navType || 'replace',
                      url: `${getApiVersion()}/personnelManagement/redirect?token=$token&appId=$appId&version=1.0&url=${
                        element.url
                      }`,
                    })
                  }}
                >
                  <Button
                    borderColor="var(--ow-color-white-100)"
                    textColor="var(--ow-color-white-100)"
                    type="primary"
                    className="mr-2"
                  >
                    {element.title}
                  </Button>
                </div>
              )}
              {/* 下载中心 */}
              {element.type === 'download-center' && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    routeTo({
                      navType: 'push',
                      url: `/apps/${appId}/pages/download-center${window.location.search}`,
                      project: 'web',
                    })
                  }}
                >
                  <IconMaps
                    type={element.icon}
                    width={24}
                    height={24}
                    fill="white"
                  />
                </div>
              )}
              {/* 下载用户操作手册(也有可能是下载其他文件) */}
              {element.type === 'download' && (
                <div
                  onClick={() => {
                    window.open(element.link)
                  }}
                >
                  <IconMaps
                    type={element.icon}
                    width={24}
                    height={24}
                    fill="white"
                  />
                </div>
              )}
              {/* 修改密码 */}
              {element.type === 'upd_password' && <UpdPassword />}
              {/* 用户头像 + 退登 */}
              {element.type.startsWith('user_avatar') && (
                <UserCenter
                  userInfo={{ ...userInfo, ...element }}
                  onMenuSelect={onMenuSelect}
                  dropDown={element.dropDown}
                />
              )}
            </Fragment>
          )
        })}
      </div>
    )
  }
)

const LeftComp = forwardRef((props, ref) => {
  const { tpl } = getQuery()
  const { customInfo } = useCustomInfoSWR(tpl)
  const isWrap = customInfo.navTitleStyle ? customInfo.navTitleStyle.wrap : true
  console.log('login->>', customInfo)
  return (
    <div ref={ref} className="flex items-center pr-10 hidden md:flex">
      {customInfo.navIcon && (
        <IconMaps
          type={customInfo.navIcon.icon}
          fill={customInfo.navIcon.fill || 'white'}
          width={customInfo.navIcon.width || 30}
          size={customInfo.navIcon.width || 30}
          height={customInfo.navIcon.height || 30}
        />
      )}
      {customInfo.navTitle && (
        <span
          style={{
            fontSize: '18px',
            margin: '0 20px 0 16px',
            width: isWrap ? '253px' : 'auto',
            display: 'inline-block',
            fontWeight: '600',
            whiteSpace: isWrap ? 'pre-wrap' : 'nowrap',
          }}
          className="ow-text-inverse-color"
        >
          {customInfo.navTitle}
        </span>
      )}
    </div>
  )
})

const SecondNavComp = (
  childrenDataNav,
  isNeedSetCurrentNav,
  setCurrentNav,
  childrenData,
  isShowTree,
  children
) => {
  // console.log('childrendatata', childrenDataNav, childrenData)
  if (isNeedSetCurrentNav(childrenDataNav)) setCurrentNav(childrenDataNav)
  if (childrenData.children && childrenData.children.length) {
    return (
      <div className="flex h-full flex-1">
        {isShowTree && <TreeNav treeData={childrenData.children} />}
        {children}
      </div>
    )
  }
  return children
}

// 二级导航是树结构
const RenderSecondNavIsTree = function ({
  onMenuSelect,
  appId,
  childrenData,
  currentNav,
  setCurrentNav,
  treeNavShowClick,
  children,
}) {
  const { isShowTree } = useNavStore((state) => pick(state, ['isShowTree']))
  // 是否有子导航
  const isHasChildrenNav = childrenData.children && childrenData.children.length
  // 是否需要设置当前选中导航信息 currentNav
  // currentNav 为空 && childrenData不为空
  const isNeedSetCurrentNav = (childrenDataNav) => {
    return (
      Object.keys(childrenDataNav).length &&
      !childrenDataNav.children &&
      !Object.keys(currentNav).length
    )
  }

  return (
    <MenuSecond
      appId={appId}
      onMenuSelect={onMenuSelect}
      menuData={null}
      treeNavShowClick={treeNavShowClick}
      isShowTreeSwitch={isHasChildrenNav}
      secondNav={(childrenDataNav) => {
        return SecondNavComp(
          childrenDataNav,
          isNeedSetCurrentNav,
          setCurrentNav,
          childrenData,
          isShowTree,
          children
        )
      }}
      operateComps={<OperateContainer />}
    />
  )
}

const NotTreeSecondProp = (
  childrenDataNav,
  currentNav,
  isNeedSetCurrentNav,
  setCurrentNav,
  isNeedShowTreeNav,
  children
) => {
  // console.log('childrendatata', childrenDataNav, currentNav)
  if (isNeedSetCurrentNav(childrenDataNav)) setCurrentNav(childrenDataNav)
  if (isNeedShowTreeNav(childrenDataNav)) {
    return (
      <div>
        <TreeNav treeData={childrenDataNav.children} />
        {children}
      </div>
    )
  }
  return children
}
// 二级导航不是树结构
const RenderSecondNavIsNotTree = function ({
  onMenuSelect,
  appId,
  childrenData,
  setCurrentNav,
  currentNav,
  treeNavShowClick,
  children,
}) {
  // 是否需要设置当前选中导航信息 currentNav
  // currentNav 为空 && childrenDataNav
  const isNeedSetCurrentNav = (childrenDataNav) => {
    return (
      Object.keys(childrenDataNav).length &&
      !childrenDataNav.children &&
      !Object.keys(currentNav).length
    )
  }
  // 是否需要显示TreeNav左侧导航
  // childrenDataNav 有children && childrenIsTree为true
  const isNeedShowTreeNav = (childrenDataNav) => {
    return (
      childrenDataNav.children &&
      childrenDataNav.children.length &&
      childrenDataNav.childrenIsTree
    )
  }
  return (
    <MenuSecond
      appId={appId}
      onMenuSelect={onMenuSelect}
      menuData={childrenData.children}
      treeNavShowClick={treeNavShowClick}
      secondNav={(childrenDataNav) => {
        return NotTreeSecondProp(
          childrenDataNav,
          currentNav,
          isNeedSetCurrentNav,
          setCurrentNav,
          isNeedShowTreeNav,
          children
        )
      }}
      operateComps={<OperateContainer />}
    />
  )
}
// 二级导航部分
const RenderSecondNav = function ({
  onMenuSelect,
  appId,
  childrenData,
  setCurrentNav,
  currentNav,
  treeNavShowClick,
  children,
}) {
  return (
    <>
      {/* childrenIsTree 代表子导航数据是左侧导航，即二级导航是树结构，不需要展示横向导航 */}
      {!childrenData.childrenIsTree ? (
        <RenderSecondNavIsNotTree
          onMenuSelect={onMenuSelect}
          appId={appId}
          childrenData={childrenData}
          setCurrentNav={setCurrentNav}
          currentNav={currentNav}
          treeNavShowClick={treeNavShowClick}
        >
          {children}
        </RenderSecondNavIsNotTree>
      ) : (
        // 二级导航使用左侧树结构
        <RenderSecondNavIsTree
          onMenuSelect={onMenuSelect}
          appId={appId}
          childrenData={childrenData}
          setCurrentNav={setCurrentNav}
          currentNav={currentNav}
          treeNavShowClick={treeNavShowClick}
        >
          {children}
        </RenderSecondNavIsTree>
      )}
    </>
  )
}

const RenderNavComp = (
  childrenData,
  isNeedSetCurrentNav,
  setCurrentNav,
  appId,
  onMenuSelectOperate,
  currentNav,
  setIsShowTree,
  isShowTree,
  children
) => {
  if (isNeedSetCurrentNav(childrenData)) {
    setCurrentNav(childrenData)
  }
  return (
    <RenderSecondNav
      appId={appId}
      onMenuSelect={onMenuSelectOperate}
      childrenData={childrenData}
      setCurrentNav={setCurrentNav}
      currentNav={currentNav}
      treeNavShowClick={() => {
        setIsShowTree(!isShowTree)
      }}
    >
      {children}
    </RenderSecondNav>
  )
}
const RenderNav = function (
  {
    rightElements,
    menuData,
    onMenuSelect,
    appId,
    isHiddenLeftComp,
    children,
    hiddenNavs,
  },
  ref
) {
  const navigateAdaptor = new NavigateAdaptor(null)
  const rightCompsRef = useRef()
  const leftCompsRef = useRef()
  const {
    setCurrentNav,
    currentNav,
    setTreeInputValue,
    isEditor,
    isShowTree,
    setIsShowTree,
    setIsRefreshTree,
  } = useNavStore((state) =>
    pick(state, [
      'setCurrentNav',
      'currentNav',
      'setTreeInputValue',
      'isEditor',
      'isShowTree',
      'setIsShowTree',
      'setIsRefreshTree',
    ])
  )

  // 是否需要设置当前选中导航信息 currentNav
  // currentNav 为空 && childrenData不为空
  const isNeedSetCurrentNav = (childrenData) => {
    return (
      currentNav &&
      !Object.keys(currentNav).length &&
      !childrenData.children &&
      Object.keys(childrenData).length
    )
  }

  const onMenuSelectOperate = (nav) => {
    // 如果是表单编辑器，就不进行以下操作
    if (!isEditor) {
      // 要跳转的url和当前浏览器的url不一致，才进行下一步操作
      if (!navigateAdaptor.getCurrentLocation().includes(nav.matchUrl)) {
        setCurrentNav({})
        setTreeInputValue('')
        if (!nav.children) setCurrentNav(nav)
      }
    }
    onMenuSelect(nav)
    setIsRefreshTree(true)
  }
  return (
    <MenuFirst
      ref={ref}
      appId={appId}
      menuData={menuData}
      hiddenNavs={hiddenNavs}
      rightComponent={
        <UserInfoComp
          appId={appId}
          ref={rightCompsRef}
          mode="horizontal"
          onMenuSelect={onMenuSelectOperate}
          rightElements={rightElements}
        />
      }
      onMenuSelect={onMenuSelectOperate}
      leftComponent={!isHiddenLeftComp && <LeftComp ref={leftCompsRef} />}
      secondNav={(childrenData) => {
        return RenderNavComp(
          childrenData,
          isNeedSetCurrentNav,
          setCurrentNav,
          appId,
          onMenuSelectOperate,
          currentNav,
          setIsShowTree,
          isShowTree,
          children
        )
      }}
    />
  )
}
export default forwardRef(RenderNav)
